/* istanbul ignore file */

import React from 'react'

import { Locale } from '@src/Application/Types/Locale'
import { Translations } from '@src/Application/Types/TranslationTypes'

type ContextType = {
    locale: Locale
    translations: Translations
    sendMixpanelEvents: boolean
    setSendMixpanelEvents: (sendMixpanelEvents: boolean) => void
}

const defaultState: ContextType = {
    locale: 'en',
    translations: {
        en: {},
        es: {},
        de: {},
        nl: {},
        ar: {},
    },
    sendMixpanelEvents: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSendMixpanelEvents: () => {},
}

export const Context = React.createContext<ContextType>(defaultState)
